export const REFUND_REASONS = [
  "Изменились обстоятельства: состояние здоровья, переезд",
  "Не подошёл формат занятий",
  "Неудобное расписание",
  "Финансовые причины",
  "Не устроило качество услуг",
  "Проблемы с адаптацией ребёнка: плачет, не заходит в воду",
  "Другое",
] as const;

export type RefundReason = (typeof REFUND_REASONS)[number];

export interface RefundApplicationData {
  ticketId: string;
  reason: RefundReason | "";
  otherReason: string;
  status: "draft" | "submitted";
  submittedDate?: string;
}

export interface RefundFormState {
  formData: RefundApplicationData;
  showOtherInput: boolean;
  successDialogOpen: boolean;
}
